import { createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionsTypes';
const getUnitsRequest = createAction(actionTypes.GET_UNITS_REQUEST);
const getUnitsSuccess = createAction(actionTypes.GET_UNITS_SUCCESS);
const getUnitsFailure = createAction(actionTypes.GET_UNITS_FAILURE);
export const setPageType = createAction(actionTypes.SET_PAGE_TYPE);
export const setIsMenuActive = createAction(actionTypes.SET_IS_MENU_ACTIVE);
export const setHeaderStickyMenuShown = createAction(actionTypes.SET_HEADER_STICKY_MENU_SHOWN);
export const setHeaderSearchShown = createAction(actionTypes.SET_HEADER_SEARCH_SHOWN);
export const setPageLevelNavigationStickyMenuShown = createAction(actionTypes.SET_PAGE_LEVEL_NAVIGATION_STICKY_MENU_SHOWN);
export const setCompareProductsStickyMenuShown = createAction(actionTypes.SET_COMPARE_PRODUCTS_STICKY_MENU_SHOWN);
export const setLocationMismatchBarOpen = createAction(actionTypes.SET_LOCATION_MISMATCH_BAR_OPEN);
export const actions = {
    request: getUnitsRequest,
    success: getUnitsSuccess,
    failure: getUnitsFailure,
    setPageParam: setPageType,
    setIsMenuActive,
    setHeaderStickyMenuShown,
    setHeaderSearchShown,
    setPageLevelNavigationStickyMenuShown,
    setCompareProductsStickyMenuShown,
    setLocationMismatchBarOpen,
};
